/*
 * @Author: MX
 * @Date: 2020-11-03 09:19:38
 * @Description:
 */
// crud配置文件
export default {
  // 标题
  sumText: "合 计",
  // 尺寸
  menuWidth: 120,
  menuXsWidth: 100,
  align: "left", //  表格列单元格对齐
  menuAlign: "center",
  headerAlign: "left",
  // 图标
  cancelBtnIcon: "el-icon-delete",
  viewBtnIcon: "iconfont iconbiaodan-chakan font-18",
  editBtnIcon: "iconfont iconbiaodan-bianji font-18",
  delBtnIcon: "iconfont iconbiaodan-shanchu font-18",
  addBtnIcon: "iconfont icon-icon_anniu_xinzeng",
  printBtnIcon: "el-icon-plus",
  excelBtnIcon: "el-icon-plus",
  searchBtnIcon: "iconfont icon-chazhao",
  emptyBtnIcon: "iconfont icon-qingchu",
  saveBtnIcon: "el-icon-check",
  columnBtnIcon: "el-icon-menu",
  filterBtnIcon: "el-icon-tickets",
  refreshBtnIcon: "el-icon-refresh",
  searchBoxBtnIcon: "iconfont iconchaxun3",
  //   查看 iconchakan1
  // 编辑 iconbianji1
  // 删除 iconshanchu2
  // 重置密码 iconzhongzhimima2
  // 账号解锁 iconzhanghaojiesuo
  // 复制 iconfuzhi
  // 收件 iconshoujian
  // 派件 iconpaijian
  // 确认入库 iconquerenruku
  // 下线 iconxiaxian1
  // 撤回 iconchehui
  // 预警设置 iconyujingshezhi
  // 查询 iconchaxun3
  // 增加 iconzengjia
  // 作废 iconzuofei1
  // 审核 iconshenhe1
  // 驳回 iconbohui2
  // 问题件回复 iconwentijianhuifu1
  // 回复明细 iconhuifumingxi
  // 完结 iconwanjie
  // 显隐
  viewBtn: true,
  editBtn: true,
  cancelBtn: true,
  addBtn: true,
  addRowBtn: false,
  printBtn: false,
  excelBtn: false,
  delBtn: true,
  cellBtn: false,
  dateBtn: false,
  refreshBtn: false,
  columnBtn: false,
  filterBtn: false,
  searchBtn: false,
  menuBtn: false,
  searchSubBtn: true,
  searchResetBtn: true,
  selectClearBtn: true,
  searchSenior: false,
  searchShow: true,
  tip: false,
  dialogHeight: "auto",
  dialogWidth: "700px",
  formFullscreen: false,
  customClass: "pudo_dialog",
  pageBackground: true,
  page: true,
  menu: true,
  indexLabel: "序号",
  filterMultiple: true,
  calcHeight: 0,
  title: "表格标题",
  width: "100%",
  dateDefault: true,
  // 搜索参数
  searchMultiple: ["checkbox", "tree", "select"],
  labelPosition: "left", // 表单label的位置
  labelWidth: 200, // 表单label的宽度
  border: true, // 列表是否有border,
  backgroundHeaderCellStyle: {
    "background-color": "#f7f7f7",
    color: "#808080",
    "border-color": "#d8d8d8",
    height: "48px",
  },
};
